import React from "react";
import { useListing } from "@/providers";
import { PROFILE_IMAGE_SERVER_URL, SERVER_IMAGES_URL } from "@/constants";
import { Link } from "react-router-dom";
export const LodgingHostDetails = () => {
  const { listingDetails } = useListing();

  const {
    type_of_space,
    lodging_type,
    no_of_guest,
    no_of_bedrooms,
    no_of_beds,
    no_of_bathrooms,
    host,
  } = listingDetails;
  console.log(host, "host");
  return (
    <div className="block-body border-bottom-gray !p-0">
      <div className="d-flex justify-content-between">
        <div>
          <h2 className="title">
            {type_of_space} - {lodging_type} <br />
            Hosted by{" "}
            <Link
              to={`/user-profile?name=${host?.display_name}`}
              state={{ host_id: host?.id, email: host?.email }}
            >
              {" "}
              {host?.display_name}{" "}
            </Link>
          </h2>

          <div
            style={{ paddingTop: "10px" }}
            className="property-details text-start sub-title"
          >
            {no_of_guest + " "} Guests <span>•</span> {no_of_bedrooms + " "}
            Bedrooms <span>•</span>
            {" " + no_of_beds + " "}
            Beds <span>•</span> {no_of_bathrooms + " "} Baths
          </div>
        </div>

        <div style={{ width: "150px" }} className="host-avatar no-print">
          <img
            src={
              host?.image !== null
                ? `${PROFILE_IMAGE_SERVER_URL}/${host?.image}`
                : "images/avatar/avatar-bg.png"
            }
            alt="Host Avatar"
          />
        </div>
      </div>
    </div>
  );
};
